import { MinimalMediaTarget } from './minimal_target';
import { MediaManager } from './media_manager';

type MediaItem = {
   data: any;
   toWikiText: () => string;
};

export const activateMediaManager = (accepts: 'profile_image' | 'wiki_media') =>
   new Promise<MediaItem>(resolve => {
      const target = new MinimalMediaTarget({
         customAttach: (mediaItem: MediaItem, finished: any) => {
            if (mediaItem) {
               resolve(mediaItem);
            }
            // Finished expects the old media item in the case of mutation
            // and a success boolean.
            finished(null, true);
         },
         accepts,
      });
      // cast to any because ts does not see the 'browse' event on the state machine (see media_manager.js)
      (MediaManager as any).browse(target);
   });
